// src/theme/index.js
import { createTheme } from "@mui/material/styles";
import { theme as lightTheme } from "./blaynaTheme";

// Build a dark variant by cloning light and overriding palette/surfaces
export const darkTheme = createTheme({
  ...lightTheme,
  palette: {
    ...lightTheme.palette,
    mode: "dark",
    primary:   { main: "#00B89A" },
    secondary: { main: "#4DA3FF" },
    background:{ default: "#0B1320", paper: "#0F1828" },
    text: { primary: "#E6E8EE", secondary: "#A6ADBB" },
    divider: "rgba(230,232,238,0.08)",
  },
  components: {
    ...lightTheme.components,
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: "#0B1320", color: "#E6E8EE" },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#0F1828",
          border: "1px solid rgba(230,232,238,0.08)",
          boxShadow: "0 8px 28px rgba(0,0,0,.25)",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: "#0F1828",
          color: "#E6E8EE",
          borderBottom: "1px solid rgba(230,232,238,0.08)",
        },
      },
    },
  },
});

// Re-export the light theme so imports stay simple
export { lightTheme };
// Optional alias if some files still do `import { theme } from "./theme"`
export { lightTheme as theme };
